// src/controller/Auth.controller.ts
import Input from "sap/m/Input";
import BaseController from "./BaseController";
import { AuthService } from "../service/auth/authService";
import { container } from "tsyringe";
import "reflect-metadata";

export default class AuthController extends BaseController {
	private readonly authService: AuthService = container.resolve(AuthService);

	async onLogin(): Promise<void> {
		const username = this.getInputValue("usernameInput").trim();
		const password = this.getInputValue("passwordInput");

		if (!username) {
			this.showWarningMessage(await this.getText("usernameRequired"));
			return;
		}
		if (!password) {
			this.showWarningMessage(await this.getText("passwordRequired"));
			return;
		}

		const ok = await this.executeWithErrorHandling(
			async () => {
				await this.authService.login({ email: username, password });
				return true;
			},
			await this.getText("loggingIn"),
			undefined,
			await this.getText("loginFailed")
		);

		if (ok){
 			this.getRouter().navTo("landingPage");
			(this.byId("passwordInput") as Input).setValue("");
		}
	}

	private getInputValue(id: string): string {
		return (this.byId(id) as Input).getValue();
	}
}
